var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.897,
    height: 22.214,
    viewBox: "0 0 11.897 22.214",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    transform: "translate(-63.62 -997.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-facebook-f",
    "data-name": "Icon awesome-facebook-f",
    d: "M12.727,12.5l.617-4.02H9.487V5.866a2.01,2.01,0,0,1,2.267-2.172h1.754V.272A21.386,21.386,0,0,0,10.394,0C7.217,0,5.141,1.925,5.141,5.411V8.475H1.609V12.5H5.141v9.719H9.487V12.5Z",
    transform: "translate(62.011 997.893)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ac9af657386366a98afb7855d33b4f3c.svg";
export { ForwardRef as ReactComponent };